module.exports = __webpack_public_path__ + "static/OpenInvest-8e22fc52f28e4222e1ab121cee58c87f.jpg";